"use strict";
/**
 * Common valiation regular expressions such as email, string, etc.
 */
var specialChars = /^[^!@#$%^&*()+=><?]*$/;
var _rules = {
    email : /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, // http://www.w3.org/TR/html5/forms.html%23valid-e-mail-address
    password : /^.{5,128}$/,
    special_characters : specialChars,
    name: specialChars,
    digits: /\d/,
    numeric : /^[0-9]*$/,
    floating : /^[0-9\.]*$/,
    greater_than_one : /^[1-9][0-9]*$/,
    url : /^((http(?:s)?\:\/\/|)[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]+)*\.[a-zA-Z]{2,6}(?:\/?|(?:\/[\w\-]+)*)(?:\/?|\/\w+\.[a-zA-Z]{2,4}(?:\?[\w]+\=[\w\-]+)?)?(?:\&[\w]+\=[\w\-]+)*)$/,
    price : /^(?=.*[1-9])\d*(?:(\.|\,)\d{1,2})?$/,
    itemPrice : /^[1-9]\d{0,2}(?:,?\d{3})*(?:\.\d{1,2})?$/,
    // Note* Month/Year pattern accepts either 2 or 4 digits for the year, and
    month_year : /^[0-9]{1}[1-2]{1}\s?\/\s?[0-9]{2}([0-9]{2})?$/,
    measurement : /^-?(?=.*[1-9])(\d*)(\.\d+)?$/,
    // currency string optionally delimited by commas without decimal amount
    currencyString: /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*?$/,
    // currency string optionally delimited by periods without decimal amount
    currencyStringEur: /^[+-]?[0-9]{1,3}(?:\.?[0-9]{3})*?$/,
    notAllCaps : function (val) {
        val = val.replace(/[^A-Za-z]+/g, '');
        var re = /[a-z]/;
        if (val === '') {
            return true;
        }
        return re.test(val);
    }
};

module.exports = _rules;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/validation/deprecated/helpers/common-rules.js
// module id = 118
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55